export default __webpack_public_path__ + "static/media/cobrand-Santander.38afbfd1.svg";